import React from 'react';
import PropTypes from 'prop-types';
import TagInput from 'library/components/tag-input';
import { resolve } from 'library/helpers/path-resolver';

import 'apps/pathways/styles/start/steps/military-experience.scss';
import 'apps/pathways/styles/start/main.scss';

const MOC = {
  'Air Force': 'AFSC Codes',
  'Army': 'MOS Codes',
  'Marine Corps': 'MOS Codes',
  'Navy': 'Ratings',
  'Coast Guard': 'Ratings'
};

class MilitaryExperience extends React.PureComponent {
  render () {
    const {
      onChange,
      branch,
      active
    } = this.props;
    return (
      <div className="experiences-form-container">
        <label htmlFor='branch'>
            Military Branch
          <select
            aria-label='branch'
            required={active}
            aria-required="true"
            disabled={!active}
            onChange={onChange}
            value={resolve(this.props, 'branch', '')}
            name='branch'
            id='branch'>

            <option value=""> -- Select One -- </option>
            <option value="Army">Army</option>
            <option value="Navy">Navy</option>
            <option value="Air Force">Air Force</option>
            <option value="Marine Corps">Marines</option>
            <option value="Coast Guard">Coast Guard</option>

          </select>
        </label>

        <label htmlFor='code'>
          {MOC[branch] || 'Military Occupation Codes'}
          <TagInput
            className="military-code-picker"
            aria-label='code'
            required={active}
            aria-required="true"
            disabled={(resolve(this.props, 'branch', '').length == '') || !active}
            name='code'
            id='code'
            onChange={onChange}
            value={resolve(this.props,'code', '')}
          />

        </label>
      </div>
    );
  }
}

MilitaryExperience.propTypes = {
  onChange: PropTypes.func,
  branch : PropTypes.string,
  code: PropTypes.string,
  id: PropTypes.number,
  active: PropTypes.bool
};

export default MilitaryExperience;
